import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import React, { useMemo } from 'react';
import { constants } from '../../../common';
import { CheckIcon } from '../../icons';
import './style.scss';

const { issueSortTypes } = constants;

const sortOptions = [
   { id: null, name: 'Default' },
   issueSortTypes.MOST_IMPORTANT,
   issueSortTypes.MOST_URGENT,
   issueSortTypes.RECENTLY_RAISED
];

const toMenuValue = (idIssueSortType) => (idIssueSortType == null ? 'default' : String(idIssueSortType));

const IssueSort = ({ idIssueSortType = null, onChange }) => {
   const selected = useMemo(
      () => sortOptions.find((sort) => sort.id === idIssueSortType) || sortOptions[0],
      [idIssueSortType]
   );

   const onValueChange = (value) => {
      onChange(value === 'default' ? null : Number(value));
   };

   return (
      <div className='issue-sort'>
         <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
               <button className='issue-sort-trigger' aria-label={`Sort issues by ${selected.name}`}>
                  {selected.id == null ? 'Sort by' : `Sort by: ${selected.name}`}
               </button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content className='DropdownMenuContent issue-sort-menu' sideOffset={5} align='end'>
               <DropdownMenu.RadioGroup value={toMenuValue(idIssueSortType)} onValueChange={onValueChange}>
                  {sortOptions.map((sort) => (
                     <DropdownMenu.RadioItem
                        key={toMenuValue(sort.id)}
                        className='DropdownMenuRadioItem'
                        value={toMenuValue(sort.id)}>
                        <DropdownMenu.ItemIndicator className='DropdownMenuItemIndicator'>
                           <CheckIcon fontSize='small' />
                        </DropdownMenu.ItemIndicator>
                        {sort.name}
                     </DropdownMenu.RadioItem>
                  ))}
               </DropdownMenu.RadioGroup>
            </DropdownMenu.Content>
         </DropdownMenu.Root>
      </div>
   );
};

export default IssueSort;
